import { useAuthDialogs } from '@entities/Authentication/model.ts';
import cn from 'classnames';
import type { FC } from 'react';
import { useWatch } from 'react-hook-form';
import { doFormatEmail } from '@shared/helpers/index.ts';
import { useAppDispatch } from '@shared/hooks';
import type { PlatformSettings, RegistrationMethod } from '@shared/types/common';
import { CommonButton } from '@shared/ui';
import { closeAuthModal } from '@src/library/redux/modal';
import { AuthForm } from '@src/modules/Authentication/AuthFrom';
import CustomInput from '@src/modules/Authentication/CustomInput';
import { ModalError } from '@src/modules/Authentication/frames/modal-error';
import Timer from '@src/modules/Authentication/Timer';
import * as st from './styles.module.scss';

interface Props {
  model: any;
  settings: PlatformSettings;
  type: RegistrationMethod;
  stepRepeat: number;
  setStepRepeat: (stepRepeat: number) => void;
}

export const CodeStep: FC<Props> = ({ model, settings, type, stepRepeat, setStepRepeat }) => {
  const is_call_active = settings.is_call_active;
  const is_sms_active = settings.is_sms_active;
  const passCode: string = useWatch({ name: 'passcode', control: model.controlPassCode });
  const dispatch = useAppDispatch();
  const { onCantVerifyCode } = useAuthDialogs();
  // const { redirectToSupportPage } = useSupportPageRedirect();
  const errorMessage = model.passcodeErrors?.passcode?.message;
  const getTextContent = () => {
    if (model?.email) {
      return (
        <p>
          <div
            className={st.firstTextBlock}
          >{`Введите код подтверждения из письма, отправленного на адрес ${doFormatEmail(model.email)}`}</div>
          <div>{'Если вы не получили письмо, проверьте спам или нажмите “Отправить повторно"'}</div>
          {/*{`Введите код подтверждения из письма, отправленного на адрес ${doFormatEmail(model.email)}\n\n` +*/}
          {/*  '\n' +*/}
          {/*  'Если вы не получили письмо, проверьте спам или нажмите “Отправить повторно"'}*/}
        </p>
      );
    } else {
      if (is_call_active && type === 'CALL') {
        return (
          <p>{`На указанный Вами номер ${model.phone.replace(
            /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/,
            '+$1 $2 $3 $4 $5'
          )} поступит звонок. Введите последние 4 цифры.`}</p>
        );
      }
      if (is_sms_active && type === 'SMS') {
        return (
          <p>{`На указанный Вами номер ${model.phone.replace(
            /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/,
            '+$1 $2 $3 $4 $5'
          )} придет смс. Введите полученные 4 цифры.`}</p>
        );
      }
    }
  };
  const getRepeatButtonContent = () => {
    if (model?.email) {
      return 'Отправить повторно';
    } else {
      if (is_call_active && type === 'CALL') {
        return 'Звонок не поступил';
      }
      if (is_sms_active && type === 'SMS') {
        return 'Смс не пришло';
      }
    }
  };
  return (
    <AuthForm onSubmit={model.submitCode((data: any) => model.checkCode(data))}>
      <div className={st.block__up}>
        <CustomInput
          tabindex={0}
          type="passcode"
          name="passcode"
          control={model.controlPassCode}
          error={model.passcodeErrors?.passcode}
          disabled={model.isLoading}
        />

        <div className={st.wrapper__center}>
          <div className={st.passcode}>{getTextContent()}</div>
          <div className={st.wrapper__column}>
            {model.showTimer && (
              <div className={st.timer}>
                <Timer
                  timeout={59000}
                  callback={() => {
                    model.timerAction();
                    // model.setCaptchaToken(null);
                    // setStepRepeat(2);
                  }}
                />
              </div>
            )}
            <button
              disabled={model?.isLoading}
              tabIndex={0}
              className={cn(st.repeatSMS)}
              type="reset"
              style={{
                display: `${model.showTimer ? 'none' : 'flex'}`,
              }}
              onClick={() => {
                // если есть email в данный момент - повторяем запрос по почте
                if (model?.email) {
                  model?.repeatEmailCodeStep();
                } else {
                  if (stepRepeat === 1) {
                    model.setStep(2.1);
                    setStepRepeat(2);
                  }
                  if (stepRepeat === 2) {
                    model.setStep(2.2);
                    setStepRepeat(3);
                  }
                  if (stepRepeat === 3) {
                    onCantVerifyCode({ onConfirm: () => dispatch(closeAuthModal()) });
                    // dispatch(
                    //   openNotifyModal({
                    //     needClose: true,
                    //     isOnConfirmShouldNotWorkOnCloseModal: true,
                    //     text: 'Если у вас не получилось зарегистрироваться, обратитесь в техническую поддержку',
                    //     confirmText: 'Техническая поддержка',
                    //     title: 'Уведомление',
                    //     confirm: () => {
                    //       redirectToSupportPage();
                    //       dispatch(closeAuthModal());
                    //     },
                    //   })
                    // );
                    // model.setStep(4);
                  }
                }
              }}
            >
              {getRepeatButtonContent()}
            </button>
          </div>
        </div>
      </div>

      {errorMessage ? (
        <ModalError error={errorMessage} />
      ) : (
        <CommonButton
          className={cn(st.confirmButton, passCode?.length > 3 && st.visible)}
          tabIndex={0}
          type="submit"
          disabled={model.isLoading}
        >
          Далее
        </CommonButton>
      )}
    </AuthForm>
  );
};
